import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { ottumwaConfig } from "./data";

export default function OttumwaPage() {
  return <CityPageTemplate config={ottumwaConfig} />;
}